<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Campo</mat-label>
                                <input type="text" matInput formControlName="Faixa_azul_campo" id="txtFxAzulCampo"
                                    maxlength="255" #txtFxAzulCampo readonly class="InputBlockColor">
                                <!-- <mat-autocomplete #auto12="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptions | async" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtFxAzulCampo.value.length}} / 255 </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Umidade de Colheita</mat-label>
                                <input type="text" matInput formControlName="Faixa_azul_umidade_de_colheita"
                                    id="txtAzulUmidColh" maxlength="3" #txtAzulUmidColh readonly
                                    class="InputBlockColor">
                                <!-- <mat-autocomplete #auto13="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptions | async" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtAzulUmidColh.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_umidade_de_colheita)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Temperatura de Secagem <span
                                        class="InputRequired">{{required}}</span></mat-label>
                                <mat-select #txtFxAzulCampo formControlName="Faixa_azul_temperatura_de_secagem"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxAzulTempSec($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsFxTempSecagem" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_temperatura_de_secagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul sem Vapor ou Ventilação <span
                                        class="InputRequired">{{required}}</span></mat-label>
                                <mat-select #txtFxAzulVapVen formControlName="Faixa_azul_sem_vapor_ou_ventilacao"
                                    disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterFxAzulVaporVen($event.target.value)">
                                    <mat-option *ngFor="let item of listOptionsFxSemVaporVent" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_sem_vapor_ou_ventilacao)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Ressecagem</mat-label>
                                <input matInput [matAutocomplete]="auto16" formControlName="Faixa_azul_ressecagem"
                                    id="txtFxAzulResec" maxlength="3" #txtFxAzulResec readonly class="InputBlockColor">
                                <mat-autocomplete #auto16="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptions | async" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtFxAzulResec.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_ressecagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Transbordo</mat-label>
                                <input type="text" matInput formControlName="Faixa_azul_transbordo"
                                    id="txtFxAzulTransbordo" maxlength="3" #txtFxAzulTransbordo readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_transbordo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Claro Temperatura Carga</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto17"
                                    formControlName="Faixa_azul_claro_temperatura_carga" id="txtFxAzulClrTempCarga"
                                    maxlength="3" #txtFxAzulClrTempCarga readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_claro_temperatura_carga)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Claro Tempo de Patio</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto18"
                                    formControlName="Faixa_azul_claro_tempo_de_patio" id="txtFxAzulClrTempPatio"
                                    maxlength="3" #txtFxAzulClrTempPatio readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_claro_tempo_de_patio)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Escuro Temperatura Carga</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto19"
                                    formControlName="Faixa_azul_escuro_temperatura_carga" id="txtFxAzulEscTempCarga"
                                    maxlength="3" #txtFxAzulEscTempCarga readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_escuro_temperatura_carga)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Escuro Tempo de Patio</mat-label>
                                <input type="text" matInput [matAutocomplete]="auto20"
                                    formControlName="Faixa_azul_escuro_tempo_de_patio" id="txtFxAzulEscTempPatio"
                                    maxlength="3" #txtFxAzulEscTempPatio readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_escuro_tempo_de_patio)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row pt-3">
                        <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Escuro Granel Tempo de Transporte
                                </mat-label>
                                <input type="text" matInput [matAutocomplete]="auto21"
                                    formControlName="Faixa_azul_escuro_granel_tempo_de_transporte"
                                    id="txtFxAzulEscGranelTempTrans" maxlength="3" #txtFxAzulEscGranelTempTrans readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_escuro_granel_tempo_de_transporte)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>


<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Campo
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input type="text" matInput formControlName="Faixa_azul_campo" id="txtFxAzulCampo"
                                    maxlength="255" #txtFxAzulCampo readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtFxAzulCampo.value.length}} / 255 </mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Umidade de Colheita
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input type="text" matInput formControlName="Faixa_azul_umidade_de_colheita"
                                    id="txtAzulUmidColh" maxlength="3" #txtAzulUmidColh readonly
                                    class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtAzulUmidColh.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_umidade_de_colheita)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Ressecagem
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input matInput [matAutocomplete]="auto16" formControlName="Faixa_azul_ressecagem"
                                    id="txtFxAzulResec" maxlength="3" #txtFxAzulResec readonly class="InputBlockColor">
                                <mat-autocomplete #auto16="matAutocomplete">
                                    <mat-option *ngFor="let item of filteredOptions | async" [value]="item.name">
                                        {{item.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="end">{{txtFxAzulResec.value.length}} / 3</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Faixa_azul_ressecagem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Faixa Azul Tempo de Patio
                                    <span class="InputRequired">{{required}}</span></mat-label>
                                <input type="text" matInput [matAutocomplete]="auto18"
                                    formControlName="faixa_azul_tempo_de_patio" id="txtFxAzulClrTempPatio" maxlength="3"
                                    #txtFxAzulClrTempPatio readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.faixa_azul_tempo_de_patio)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>